import { HeroCinematic } from "@/components/marketing/HeroCinematic";

// Hero visual: the ARI conversation held in a premium glass panel (the container lives inside
// HeroCinematic). This wrapper sizes the panel and lends a soft warm-gold ambient so the panel
// sits inside the hero environment rather than on top of it.
export const HeroFilm = () => (
  <div className="relative hero-pristine flex items-center justify-center h-full" data-testid="hero-film">
    <div className="relative w-full aspect-square max-w-[560px] lg:max-w-[600px] mx-auto">
      <HeroCinematic />
    </div>
  </div>
);

export default HeroFilm;
